import React from 'react';
import { ChevronLeft, Heart, IconFormIcons } from 'shared/assets/icons';
import { LifeAreaContextMenu } from 'shared/components/connected/life-area-context-menu';
import { Icon } from 'shared/components/ui/icon';
import { Colors, IconButton, Sizes } from 'shared/components/ui/icon-button';
import { useContextMenuState } from 'shared/hooks/use-context-menu-state';
import { Paths } from 'shared/routes';
import { DataType } from 'shared/types/data-type';
import { LifeArea } from 'shared/types/life-area';
import { lifeAreaOtherID } from 'shared/types/orderable-section';
import { replaceUrlParams } from 'shared/utils/replace-url-params';

import * as Styled from './life-area-item-card.style';

export type LifeAreaListCardProps = {
  lifeArea: LifeArea;

  onCollapse?: (e: React.MouseEvent) => void;
  collapsed?: boolean;
  isGrabbable?: boolean;
  isGrabbed?: boolean;
};

export const LifeAreaItemCard: React.FC<LifeAreaListCardProps> = ({
  lifeArea,
  onCollapse,
  collapsed,
  isGrabbable,
  isGrabbed,
}) => {
  const {
    open: openMenu,
    close: closeMenu,
    position: menuPosition,
  } = useContextMenuState({
    disabled: !!lifeArea?.frozenAt,
  });

  const _onClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onCollapse?.(e);
  };

  const isFakeLifeArea = lifeArea.id === lifeAreaOtherID;

  return (
    <>
      <Styled.Container
        $isGrabbable={!!isGrabbable}
        $isGrabbed={!!isGrabbed}
        onClick={_onClick}
        onContextMenu={openMenu}
        data-component-type={DataType.LifeArea}
        data-id={lifeArea.id}
        data-title={lifeArea.name}
      >
        <Styled.Content>
          <Styled.IconContainer
            $color={lifeArea.color}
            $noBackground={lifeArea.id === lifeAreaOtherID}
          >
            <Icon icon={IconFormIcons[lifeArea.iconName] ?? Heart} />
          </Styled.IconContainer>

          <Styled.TitleContainer
            to={
              isFakeLifeArea
                ? ''
                : replaceUrlParams(Paths.LifeAreaDetail, { id: lifeArea.id })
            }
            as={isFakeLifeArea ? 'span' : undefined}
          >
            <Styled.Title>{lifeArea.name}</Styled.Title>
            {!isFakeLifeArea && (
              <Styled.ChevronContainer>
                <Icon icon={ChevronLeft} />
              </Styled.ChevronContainer>
            )}
          </Styled.TitleContainer>
        </Styled.Content>

        {!!onCollapse && (
          <IconButton
            size={Sizes.Small}
            icon={ChevronLeft}
            rotation={collapsed ? -90 : 0}
            color={Colors.Default}
            as="span"
          />
        )}
      </Styled.Container>
      {!!menuPosition && (
        <LifeAreaContextMenu
          lifeArea={lifeArea}
          onClose={closeMenu}
          location={menuPosition}
        />
      )}
    </>
  );
};
